(function($){
    const menuItemWithSubMenu = $('.handheld-navigation .menu-item:has(.sub-menu)')
    menuItemWithSubMenu.each(function(){
        const element = $(this);
        element.find('>a').on('click', function(){
            element.find('>button').click();
        })        
    })
})(jQuery)